"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isVenueVisitPlanPlannedDateInPast = exports.isVenueVisitPlanTimeSlotSelectable = exports.isVenueVisitPlanTimeSlotPassed = exports.isVenueVisitPlanTimeSlotActive = exports.getVenueVisitPlanTimeSlotStatus = exports.getVenueVisitPlanTimeSlotForInstant = exports.getVisitPlanPlannedDatesRelevantToNow = exports.getVenueVisitPlanTimeSlotBounds = exports.isVenueVisitPlanDateWithinBookingWindow = exports.getTodayInTimezone = exports.getTodayInServerTimezone = exports.resolveVenueVisitPlanTimezone = exports.getServerTimezone = exports.DEFAULT_VENUE_VISIT_PLAN_TIMEZONE = exports.VENUE_VISIT_PLAN_MAX_DAYS_AHEAD = exports.getVenueVisitPlanTimeSlotWindow = exports.isVenueVisitPlanTimeSlot = exports.VENUE_VISIT_PLAN_TIME_SLOTS_ORDERED = exports.VENUE_VISIT_PLAN_CONCRETE_TIME_SLOTS_ORDERED = void 0;
const dayjs_1 = __importDefault(require("dayjs"));
const utc_1 = __importDefault(require("dayjs/plugin/utc"));
const timezone_1 = __importDefault(require("dayjs/plugin/timezone"));
const enums_1 = require("../enums");
dayjs_1.default.extend(utc_1.default);
dayjs_1.default.extend(timezone_1.default);
const TIME_SLOT_WINDOWS = {
  [enums_1.VenueVisitPlanTimeSlot.Morning]: {
    startHour: 5,
    startMinute: 0,
    endHour: 11,
    endMinute: 0,
    label: 'Morning'
  },
  [enums_1.VenueVisitPlanTimeSlot.Midday]: {
    startHour: 11,
    startMinute: 0,
    endHour: 14,
    endMinute: 0,
    label: 'Midday'
  },
  [enums_1.VenueVisitPlanTimeSlot.Afternoon]: {
    startHour: 14,
    startMinute: 0,
    endHour: 17,
    endMinute: 0,
    label: 'Afternoon'
  },
  [enums_1.VenueVisitPlanTimeSlot.Evening]: {
    startHour: 17,
    startMinute: 0,
    endHour: 21,
    endMinute: 0,
    label: 'Evening'
  },
  [enums_1.VenueVisitPlanTimeSlot.LateNight]: {
    startHour: 21,
    startMinute: 0,
    endHour: 5,
    endMinute: 0,
    label: 'Late night',
    endsNextDay: true
  },
  // Both span the nominal full calendar day (00:00 -> 00:00 next day) — that's
  // the correct window for an *existing* plan's isPassed/countable-for-badges
  // check (someone who booked "All Day" is plausibly there the whole day).
  // "All Day" additionally has an earlier cutoff for *new* selections; see
  // isVenueVisitPlanTimeSlotSelectable.
  [enums_1.VenueVisitPlanTimeSlot.NotSure]: {
    startHour: 0,
    startMinute: 0,
    endHour: 0,
    endMinute: 0,
    label: 'Not Sure Yet',
    endsNextDay: true
  },
  [enums_1.VenueVisitPlanTimeSlot.AllDay]: {
    startHour: 0,
    startMinute: 0,
    endHour: 0,
    endMinute: 0,
    label: 'All Day',
    endsNextDay: true
  }
};
/** The 5 fixed-hour windows — excludes the flexible `NotSure`/`AllDay` values. */
exports.VENUE_VISIT_PLAN_CONCRETE_TIME_SLOTS_ORDERED = [enums_1.VenueVisitPlanTimeSlot.Morning, enums_1.VenueVisitPlanTimeSlot.Midday, enums_1.VenueVisitPlanTimeSlot.Afternoon, enums_1.VenueVisitPlanTimeSlot.Evening, enums_1.VenueVisitPlanTimeSlot.LateNight];
exports.VENUE_VISIT_PLAN_TIME_SLOTS_ORDERED = [...exports.VENUE_VISIT_PLAN_CONCRETE_TIME_SLOTS_ORDERED, enums_1.VenueVisitPlanTimeSlot.NotSure, enums_1.VenueVisitPlanTimeSlot.AllDay];
const isVenueVisitPlanTimeSlot = value => Object.values(enums_1.VenueVisitPlanTimeSlot).includes(value);
exports.isVenueVisitPlanTimeSlot = isVenueVisitPlanTimeSlot;
const getVenueVisitPlanTimeSlotWindow = timeSlot => TIME_SLOT_WINDOWS[timeSlot];
exports.getVenueVisitPlanTimeSlotWindow = getVenueVisitPlanTimeSlotWindow;
/**
 * How many days beyond today a visit plan can be scheduled for (inclusive) —
 * the picker offers today + this many days, e.g. 6 → a 7-day window.
 */
exports.VENUE_VISIT_PLAN_MAX_DAYS_AHEAD = 6;
/** Default timezone for venue visit plan windows; backend may override when validating. */
exports.DEFAULT_VENUE_VISIT_PLAN_TIMEZONE = 'America/Chicago';
const getServerTimezone = () => exports.DEFAULT_VENUE_VISIT_PLAN_TIMEZONE;
exports.getServerTimezone = getServerTimezone;
/**
 * IANA timezone used to evaluate visit-plan time slots for a venue.
 * Prefers the venue's opening-hours timezone (from Google), else Chicago.
 */
const resolveVenueVisitPlanTimezone = openingHoursTimezone => {
  const tz = openingHoursTimezone === null || openingHoursTimezone === void 0 ? void 0 : openingHoursTimezone.trim();
  return tz && tz.length > 0 ? tz : exports.DEFAULT_VENUE_VISIT_PLAN_TIMEZONE;
};
exports.resolveVenueVisitPlanTimezone = resolveVenueVisitPlanTimezone;
const getTodayInServerTimezone = () => (0, dayjs_1.default)().tz((0, exports.getServerTimezone)()).format('YYYY-MM-DD');
exports.getTodayInServerTimezone = getTodayInServerTimezone;
const getTodayInTimezone = tz => (0, dayjs_1.default)().tz(tz !== null && tz !== void 0 ? tz : (0, exports.getServerTimezone)()).format('YYYY-MM-DD');
exports.getTodayInTimezone = getTodayInTimezone;
/**
 * Whether `plannedDate` (YYYY-MM-DD) falls within the bookable window —
 * today through VENUE_VISIT_PLAN_MAX_DAYS_AHEAD days ahead, inclusive, in
 * the given timezone. Plain string comparison is safe here since both sides
 * are YYYY-MM-DD (lexicographic order matches chronological order).
 */
const isVenueVisitPlanDateWithinBookingWindow = function (plannedDate) {
  let now = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
  let tz = arguments.length > 2 ? arguments[2] : undefined;
  const timezone = tz !== null && tz !== void 0 ? tz : (0, exports.getServerTimezone)();
  const today = (0, exports.getTodayInTimezone)(timezone);
  const latest = dayjs_1.default.tz(today, timezone).add(exports.VENUE_VISIT_PLAN_MAX_DAYS_AHEAD, 'day').format('YYYY-MM-DD');
  return plannedDate >= today && plannedDate <= latest;
};
exports.isVenueVisitPlanDateWithinBookingWindow = isVenueVisitPlanDateWithinBookingWindow;
const getVenueVisitPlanTimeSlotBounds = (timeSlot, plannedDate, tz) => {
  const timezone = tz !== null && tz !== void 0 ? tz : (0, exports.getServerTimezone)();
  const window = (0, exports.getVenueVisitPlanTimeSlotWindow)(timeSlot);
  const start = dayjs_1.default.tz(plannedDate, timezone).hour(window.startHour).minute(window.startMinute).second(0).millisecond(0);
  let end = dayjs_1.default.tz(plannedDate, timezone).hour(window.endHour).minute(window.endMinute).second(0).millisecond(0);
  if (window.endsNextDay) {
    end = end.add(1, 'day');
  }
  return {
    start,
    end
  };
};
exports.getVenueVisitPlanTimeSlotBounds = getVenueVisitPlanTimeSlotBounds;
/**
 * Calendar dates whose visit plans should be considered "current" (server timezone).
 * Before 5am, includes yesterday so an active late-night plan (9pm–5am) is still visible.
 */
const getVisitPlanPlannedDatesRelevantToNow = function () {
  let now = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  let tz = arguments.length > 1 ? arguments[1] : undefined;
  const timezone = tz !== null && tz !== void 0 ? tz : (0, exports.getServerTimezone)();
  const nowTz = (0, dayjs_1.default)(now).tz(timezone);
  const today = nowTz.format('YYYY-MM-DD');
  const lateNightEnd = (0, exports.getVenueVisitPlanTimeSlotWindow)(enums_1.VenueVisitPlanTimeSlot.LateNight);
  const beforeLateNightEnds = nowTz.hour() < lateNightEnd.endHour || nowTz.hour() === lateNightEnd.endHour && nowTz.minute() < lateNightEnd.endMinute;
  if (beforeLateNightEnds) {
    return [nowTz.subtract(1, 'day').format('YYYY-MM-DD'), today];
  }
  return [today];
};
exports.getVisitPlanPlannedDatesRelevantToNow = getVisitPlanPlannedDatesRelevantToNow;
/**
 * Returns the time slot active at `now` (server timezone), or null between 5am and 5am boundaries
 * when no slot is active (there is none — morning starts at 5am).
 */
const getVenueVisitPlanTimeSlotForInstant = function () {
  let now = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  let tz = arguments.length > 1 ? arguments[1] : undefined;
  const timezone = tz !== null && tz !== void 0 ? tz : (0, exports.getServerTimezone)();
  const nowTz = (0, dayjs_1.default)(now).tz(timezone);
  const today = nowTz.format('YYYY-MM-DD');
  const yesterday = nowTz.subtract(1, 'day').format('YYYY-MM-DD');
  const lateNight = enums_1.VenueVisitPlanTimeSlot.LateNight;
  const spillover = (0, exports.getVenueVisitPlanTimeSlotBounds)(lateNight, yesterday, timezone);
  if (!nowTz.isBefore(spillover.start) && nowTz.isBefore(spillover.end)) {
    return lateNight;
  }
  // Concrete slots only — `NotSure`/`AllDay` both nominally span the whole
  // day, which would trivially "match" every instant and defeat the point
  // of this lookup (which concrete window is `now` inside).
  for (const slot of exports.VENUE_VISIT_PLAN_CONCRETE_TIME_SLOTS_ORDERED) {
    if (slot === enums_1.VenueVisitPlanTimeSlot.LateNight) {
      continue;
    }
    const {
      start,
      end
    } = (0, exports.getVenueVisitPlanTimeSlotBounds)(slot, today, timezone);
    if (!nowTz.isBefore(start) && nowTz.isBefore(end)) {
      return slot;
    }
  }
  const sameDayLateNight = (0, exports.getVenueVisitPlanTimeSlotBounds)(lateNight, today, timezone);
  if (!nowTz.isBefore(sameDayLateNight.start) && nowTz.isBefore(sameDayLateNight.end)) {
    return lateNight;
  }
  return null;
};
exports.getVenueVisitPlanTimeSlotForInstant = getVenueVisitPlanTimeSlotForInstant;
const getVenueVisitPlanTimeSlotStatus = function (timeSlot, plannedDate) {
  let now = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Date();
  let tz = arguments.length > 3 ? arguments[3] : undefined;
  if ((0, exports.isVenueVisitPlanTimeSlotPassed)(timeSlot, plannedDate, now, tz)) {
    return 'passed';
  }
  if ((0, exports.isVenueVisitPlanTimeSlotActive)(timeSlot, plannedDate, now, tz)) {
    return 'active';
  }
  return 'upcoming';
};
exports.getVenueVisitPlanTimeSlotStatus = getVenueVisitPlanTimeSlotStatus;
const isVenueVisitPlanTimeSlotActive = function (timeSlot, plannedDate) {
  let now = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Date();
  let tz = arguments.length > 3 ? arguments[3] : undefined;
  const timezone = tz !== null && tz !== void 0 ? tz : (0, exports.getServerTimezone)();
  const {
    start,
    end
  } = (0, exports.getVenueVisitPlanTimeSlotBounds)(timeSlot, plannedDate, timezone);
  const nowTz = (0, dayjs_1.default)(now).tz(timezone);
  return !nowTz.isBefore(start) && nowTz.isBefore(end);
};
exports.isVenueVisitPlanTimeSlotActive = isVenueVisitPlanTimeSlotActive;
/**
 * Returns true when the slot's end time on plannedDate is at or before now
 * in the given timezone (venue local TZ when available).
 */
const isVenueVisitPlanTimeSlotPassed = function (timeSlot, plannedDate) {
  let now = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Date();
  let tz = arguments.length > 3 ? arguments[3] : undefined;
  const timezone = tz !== null && tz !== void 0 ? tz : (0, exports.getServerTimezone)();
  const {
    end
  } = (0, exports.getVenueVisitPlanTimeSlotBounds)(timeSlot, plannedDate, timezone);
  return !(0, dayjs_1.default)(now).tz(timezone).isBefore(end);
};
exports.isVenueVisitPlanTimeSlotPassed = isVenueVisitPlanTimeSlotPassed;
/**
 * Whether `timeSlot` can still be picked as a *new* choice for `plannedDate`
 * right now — distinct from `isVenueVisitPlanTimeSlotPassed`, which answers
 * "has this slot's own window ended" and is what governs an *existing*
 * plan's status (and venue activity counts). For every slot except `AllDay`
 * the two questions have the same answer. `AllDay` is the one exception: it
 * nominally spans the whole day, but stops being a *selectable* choice as
 * soon as any concrete (fixed-hour) slot has passed — you can no longer
 * honestly say "all day" once part of the day is already gone, even though
 * the plan itself, if already booked, still legitimately runs to midnight.
 */
const isVenueVisitPlanTimeSlotSelectable = function (timeSlot, plannedDate) {
  let now = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Date();
  let tz = arguments.length > 3 ? arguments[3] : undefined;
  const timezone = tz !== null && tz !== void 0 ? tz : (0, exports.getServerTimezone)();
  if (timeSlot === enums_1.VenueVisitPlanTimeSlot.AllDay) {
    return !exports.VENUE_VISIT_PLAN_CONCRETE_TIME_SLOTS_ORDERED.some(concreteSlot => (0, exports.isVenueVisitPlanTimeSlotPassed)(concreteSlot, plannedDate, now, timezone));
  }
  return !(0, exports.isVenueVisitPlanTimeSlotPassed)(timeSlot, plannedDate, now, timezone);
};
exports.isVenueVisitPlanTimeSlotSelectable = isVenueVisitPlanTimeSlotSelectable;
const isVenueVisitPlanPlannedDateInPast = function (plannedDate) {
  let now = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
  const timezone = (0, exports.getServerTimezone)();
  const relevantDates = (0, exports.getVisitPlanPlannedDatesRelevantToNow)(now, timezone);
  const oldestRelevant = relevantDates[0];
  return plannedDate < oldestRelevant;
};
exports.isVenueVisitPlanPlannedDateInPast = isVenueVisitPlanPlannedDateInPast;
//# sourceMappingURL=venue-visit-plan-time-slot.js.map